/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-cycle
import { DesktopNavigation, MobileNavigation } from './NavBar';

const getDocHeight = () => Math.max(
  document.body.scrollHeight,
  document.documentElement.scrollHeight,
  document.body.offsetHeight,
  document.documentElement.offsetHeight,
  document.body.clientHeight,
  document.documentElement.clientHeight
);

const calculateScrollDistance = () => {
  const scrollTop = window.pageYOffset + 63; // how much the user has scrolled by
  const winHeight = window.innerHeight;
  const docHeight = getDocHeight();

  const totalDocScrollLength = docHeight - winHeight;
  const scrollPosition = Math.floor((scrollTop / totalDocScrollLength) * 100);

  return scrollPosition;
};

function SubPageHeader({ location, menu }) {
  const [scrollPosition, setScrollPostion] = useState(false);

  useEffect(() => {
    function onScroll() {
      requestAnimationFrame(() => {
        setScrollPostion(calculateScrollDistance());
      });
    }

    window.addEventListener('scroll', onScroll);
    return window.addEventListener('scroll', onScroll);
  }, [scrollPosition]);

  const scrolled = scrollPosition > 10;

  return (
    <>
      <DesktopNavigation
        pathname={location.pathname}
        menu={menu}
        scrolled={scrolled}
        scrollPosition={scrollPosition}
      />
      <MobileNavigation
        pathname={location.pathname}
        menu={menu}
        scrolled={scrolled}
        scrollPosition={scrollPosition}
      />
    </>
  );
}

SubPageHeader.propTypes = {
  location: PropTypes.shape({
    host: PropTypes.string,
    hostname: PropTypes.string,
    href: PropTypes.string,
    key: PropTypes.string,
    origin: PropTypes.string,
    pathname: PropTypes.string,
    port: PropTypes.string,
  }).isRequired,
  menu: PropTypes.shape({
    links: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        url: PropTypes.string,
      })
    ),
  }).isRequired,
};

export default SubPageHeader;
